declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute, Params } from '@angular/router';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';


declare var require: any;

import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbPayBillModal } from './paybill.modal';
import { PatientInfoByFormattedCodeController, ServicesByCategoryCodeController, ServicesByCategoryCodeRequest, NewBillData, SaveBillItemsInfoRequest, StoreLocationMaterialsRequest, StoreLocationMaterialsController, MaterialBatchInaStoreController, DoctorsListController, DoctorsListRequest, MaterialsListController, MaterialsListRequest, PurchaseOrderDetailsController, PurchaseOrderDetailsRequest, PurchaseOrderDetailsInfoController, PurchaseOrdersListController, SaveDoccumentStateRequest, GenericProcPostRequest, S_Methods, SavePurchaseOrderRequest, PurchaseOrderItemRequest, VendorsListController } from '../../../../../../src/app/ncs/models/actor/actor';
import { PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { Servicebillpipe, Storelistpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgbPaymentModal } from './modal/payment.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbBatchDetail2Modal } from '../consumptionentry/batchdetail2.modal';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { NgbSearchProviderModal } from '../ivf/ivfworkbench/searchprovider.modal';
import { NgbGoodsInvoiceModal } from './modal/goodsinvoice.modal';
import { NgbEditPOitemsModal } from './modal/editPOitems.modal';
import { NgbEditPOitems2Modal } from './modal/editPOitems2.modal';
import { NgbSearchVendorsModal } from './modal/searchvendors.modal';
import { NgbEditPOVIitems2Modal } from './modal/editPOVIitems2.modal';





@Component({
  selector: 'poviedit',
  templateUrl: './poviedit.component.html',
  styleUrls: ['./poviedit.component.scss']
  , animations: [routerTransition()]
})

export class POVIEditComponent implements OnInit {


  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public searchValue: string;
  public isvisible: boolean = true;
  public Date: Date;
  public ActorCode2: number;
  public FacilityCode: number;
  public DocID: string;
  PostingDate: NgbDateStruct;
  DeliveryDate: NgbDateStruct;
  searchTitle: string;

  public UnitPrice: number;
  public TaxPercent: number;
  public ItemTax: number;
  public Quantity: number;
  public BonusQuantity: number = 0;
  public TotalOrderQuantity: number;
  public UomName: string;
  public Mrp: number;
  public Pack: number;
  public PurchasePrice: number;
  public SalePrice: number;
  TodayDate = new Date();
  Todate = new Date();
  CurrentSavePurchaseOrderRequest: SavePurchaseOrderRequest;
  PurchaseOrderData: SavePurchaseOrderRequest;
  CurrentPurchaseOrderDetailsController: PurchaseOrderDetailsController[];
  CurrentPurchaseOrderDetailsRequest: PurchaseOrderDetailsRequest;
  PurchaseOrderDataHeader: PurchaseOrderDetailsInfoController;
  CurrentPurchaseOrderHeaderDetailsController: PurchaseOrdersListController;

  LoadItems() {
    this.CurrentPurchaseOrderDetailsRequest = new PurchaseOrderDetailsRequest();
    this.CurrentPurchaseOrderDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPurchaseOrderDetailsController();
  }
  CopyItemsToPurchaseOrder() {
    this.PurchaseOrderData.OwnerStoreName = this.CurrentPurchaseOrderHeaderDetailsController.ShipToLocation;
    this.PurchaseOrderData.PurchaseOrderCode = this.CurrentPurchaseOrderHeaderDetailsController.PurchaseOrderCode;
    this.PurchaseOrderData.PostingDate = this.CurrentPurchaseOrderHeaderDetailsController.OrderDate;
    this.PurchaseOrderData.DeliveryDate = this.CurrentPurchaseOrderHeaderDetailsController.DeliveryDate;

    this.PurchaseOrderData.Tax = this.CurrentPurchaseOrderHeaderDetailsController.Tax;
    this.PurchaseOrderData.TotalBeforeTax = this.CurrentPurchaseOrderHeaderDetailsController.GrandTotal - this.CurrentPurchaseOrderHeaderDetailsController.Tax;
      //this.CurrentPurchaseOrderHeaderDetailsController.TotalBeforeDiscount;
    this.PurchaseOrderData.GrandTotal = this.CurrentPurchaseOrderHeaderDetailsController.GrandTotal;

    this.PurchaseOrderData.Items = new Array<PurchaseOrderItemRequest>();
    for (var i = 0; i < this.CurrentPurchaseOrderDetailsController.length; i++) {
      var poItem = new PurchaseOrderItemRequest();
      var OrderItem = this.CurrentPurchaseOrderDetailsController[i];

      poItem.ItemCode = OrderItem.MaterialCode;
      poItem.ItemDescription = OrderItem.MaterialDescription;
      poItem.Quantity = OrderItem.Quantity;
      poItem.UomName = OrderItem.UOM;
      poItem.UnitPrice = OrderItem.UnitPrice;
      poItem.TaxPercent = OrderItem.TaxPercent;
      poItem.Tax = OrderItem.ItemTaxPercent;
      poItem.BonusQuantity = OrderItem.BonusQuantity;
      poItem.TotalOrderQuantity = OrderItem.TotalOrderQuantity;
      poItem.Mrp = OrderItem.MRP;
      poItem.Pack = OrderItem.Pack;
      poItem.PurchasePrice = OrderItem.PurchasePrice;
      poItem.SalePrice = OrderItem.SellingPrice;
      poItem.PurchaseOrderItemCode = OrderItem.PurchaseOrderItemCode;
      poItem.Discount = OrderItem.DiscountAmount;
      poItem.DiscountPercent = OrderItem.DiscountPercent;
      poItem.BatchNo = OrderItem.BatchNo;
      poItem.ExpiryDate = OrderItem.ExpiryDate;
      this.PurchaseOrderData.Items.push(poItem);

    }

  }
  GetPurchaseOrderDetailsController() {
    this.StartRefreshing();
    this.CurrentPurchaseOrderDetailsRequest.DOC = this.DocID;
    this.CurrentPurchaseOrderDetailsRequest.ConditionalOperator = 10;
    this.actorservice.GetPurchaseOrderDetailsController(this.CurrentPurchaseOrderDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.PurchaseOrderDataHeader = this.ApiResData.Result;
          this.PurchaseOrderData = new SavePurchaseOrderRequest();
          this.CurrentPurchaseOrderDetailsController = this.PurchaseOrderDataHeader.OrderItems;
          this.CurrentPurchaseOrderHeaderDetailsController = this.PurchaseOrderDataHeader.OrderHeader;
          this.PurchaseOrderData.DiscountAmount = this.CurrentPurchaseOrderDetailsController.filter((item) => item.DiscountAmount)
            .map((item) => +item.DiscountAmount)
            .reduce((sum, current) => sum + current);
          this.stopRefreshing();
          this.CopyItemsToPurchaseOrder();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  constructor(private router: Router,
    private actorservice: ActorService,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService,
    private modalService: NgbModal,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,
    private filter: Storelistpipe, private spinner: NgxSpinnerService


  ) { }

  ngOnInit() {
    this.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.ActorCode2 = AppData.Instance().UserLoginDetails.ActorCode;
    this.DocID = this.route.snapshot.paramMap.get('DocIDData');
    this.LoadItems();
    this.CurrentSavePurchaseOrderRequest = new SavePurchaseOrderRequest();
    this.CurrentSavePurchaseOrderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.CurrentPurchaseOrderHeaderDetailsController.OrderDate = {
    //  year: this.TodayDate.getFullYear(),
    //  month: this.TodayDate.getMonth() + 1,
    //  day: this.TodayDate.getDate()
    //};
    //this.CurrentPurchaseOrderHeaderDetailsController.OrderDate = new Date(this.parserFormatter.format(this.PostingDate));
    //this.CurrentPurchaseOrderHeaderDetailsController.DeliveryDate = new Date(this.parserFormatter.format(this.DeliveryDate));
  }
  SaveData() {
    //this.isvisible = false;
    this.spinner.show();
    this.CurrentSavePurchaseOrderRequest.DocID = this.CurrentPurchaseOrderHeaderDetailsController.DocID;
    this.CurrentSavePurchaseOrderRequest.OwnerName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePurchaseOrderRequest.OwnerLocation = AppData.Instance().SelectedBranchCode;
    this.CurrentSavePurchaseOrderRequest.PostingDate = this.CurrentPurchaseOrderHeaderDetailsController.OrderDate;
    this.CurrentSavePurchaseOrderRequest.DeliveryDate = this.CurrentPurchaseOrderHeaderDetailsController.DeliveryDate;
    this.CurrentSavePurchaseOrderRequest.SupplierCode = this.CurrentPurchaseOrderHeaderDetailsController.SupplierCode;
    this.CurrentSavePurchaseOrderRequest.SupplierName = this.CurrentPurchaseOrderHeaderDetailsController.SupplierName;
    this.CurrentSavePurchaseOrderRequest.SupplierContactPersonCode = this.CurrentPurchaseOrderHeaderDetailsController.VendorContactPerson; 
    this.CurrentSavePurchaseOrderRequest.RefDetails = this.CurrentPurchaseOrderHeaderDetailsController.RefNo;
    this.CurrentSavePurchaseOrderRequest.PurchaseOrderCode = this.CurrentPurchaseOrderHeaderDetailsController.PurchaseOrderCode;
    this.CurrentSavePurchaseOrderRequest.OrderStatus = this.CurrentPurchaseOrderHeaderDetailsController.OrderStatus;
    this.CurrentSavePurchaseOrderRequest.PayInDays = this.CurrentPurchaseOrderHeaderDetailsController.PaymentTermsinDays;
    this.CurrentSavePurchaseOrderRequest.PayAgainst = 'GRN';
    //this.CurrentSavePurchaseOrderRequest.PayAgainst = this.CurrentPurchaseOrderHeaderDetailsController.PayAgainst;
    this.CurrentSavePurchaseOrderRequest.ShipToLocation = this.CurrentPurchaseOrderHeaderDetailsController.ShipToLocationCode;
    this.CurrentSavePurchaseOrderRequest.Terms = this.CurrentPurchaseOrderHeaderDetailsController.TermsAndConditions;
    this.CurrentSavePurchaseOrderRequest.Remarks = this.CurrentPurchaseOrderHeaderDetailsController.Remarks;
    this.CurrentSavePurchaseOrderRequest.ConditionalOperator = 20;
    this.CurrentSavePurchaseOrderRequest.Items = this.PurchaseOrderData.Items;
    this.CurrentSavePurchaseOrderRequest.Tax = this.PurchaseOrderData.Tax;
    this.CurrentSavePurchaseOrderRequest.TotalBeforeTax = this.PurchaseOrderData.TotalBeforeTax;
    this.CurrentSavePurchaseOrderRequest.GrandTotal = this.PurchaseOrderData.GrandTotal;
    this.actorservice.Save<SavePurchaseOrderRequest>(
    
      this.CurrentSavePurchaseOrderRequest, S_Methods.SavePurchaseOrders
    )
      .subscribe((result) => {
        this.ApiResData = result;
        if (result.Result > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          this.spinner.hide();
          this.isvisible = false;
        }
        else {
          alertFunctions.AlertParam("Invalid Operation :- " + "...!");
          this.stopRefreshing();
          this.spinner.hide();
        }
      },
        (error) => {
          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );
  }
  Approve() {
    var saveReq = new SaveDoccumentStateRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 20052; // reque for po approval
    saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.ActionTag = "Approve";
    saveReq.DocumentType = 101; // PO docment
    saveReq.DocCode = this.CurrentPurchaseOrderHeaderDetailsController.PurchaseOrderCode;
    saveReq.DocID = this.DocID;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 20052;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            //this.spinner.hide();
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  SelectVendor() {
    const modalRef = this.modalService.open(NgbSearchVendorsModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.result.then((l: VendorsListController) => {
      this.CurrentPurchaseOrderHeaderDetailsController.SupplierCode = l.VendorCode;
      this.CurrentPurchaseOrderHeaderDetailsController.SupplierName = l.DisplayName;
      this.CurrentPurchaseOrderHeaderDetailsController.VendorContactPersonName = l.Telephone1;
    });
  }
  EditItems(PurchaseOrderData: SavePurchaseOrderRequest, input: PurchaseOrderItemRequest) {
    const modalRef = this.modalService.open(NgbEditPOVIitems2Modal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.FromScreen = 'POVI';
    modalRef.componentInstance.PurchaseOrderItem = input;
    modalRef.componentInstance.PurchaseOrderData = PurchaseOrderData;
    modalRef.componentInstance.PurchaseOrderCode = this.CurrentPurchaseOrderHeaderDetailsController.PurchaseOrderCode;
    modalRef.componentInstance.ShipToLocation = this.CurrentPurchaseOrderHeaderDetailsController.ShipToLocation;
    modalRef.componentInstance.VendorName = this.CurrentPurchaseOrderHeaderDetailsController.SupplierName;
    modalRef.result.then((l: PurchaseOrderItemRequest) => {
      input.UnitPrice = (l.PurchasePrice) / (l.Quantity * l.Pack);
      input.TaxPercent = l.TaxPercent;
      //input.ItemTax = l.Tax;
      input.Quantity = l.Quantity;
      input.BonusQuantity = l.BonusQuantity;
      input.TotalOrderQuantity = l.TotalOrderQuantity;
      input.UomName = l.UomName;
      input.Mrp = l.Mrp;
      input.Pack = l.Pack;
      input.PurchasePrice = l.PurchasePrice;
      input.Tax = (l.Quantity * l.PurchasePrice * l.TaxPercent) / 100;
      input.ItemTotal = l.Quantity * l.PurchasePrice;
      input.ItemNet = input.ItemTotal + input.Tax;
      input.Discount = l.Discount;
      input.DiscountPercent = l.DiscountPercent;
      input.BatchNo = l.BatchNo;
      input.ExpiryDate = l.ExpiryDate;
      this.CalculateTotals();
    });
  }
  CalculateTotals() {
    //alert(this.CurrentOrderDetails.length);
    this.PurchaseOrderData.Tax = this.PurchaseOrderData.Items.filter((item) => item.Tax)
      .map((item) => +item.Tax)
      .reduce((sum, current) => sum + current);

    this.PurchaseOrderData.TotalBeforeTax = this.PurchaseOrderData.Items.filter((item) => item.PurchasePrice)
      .map((item) => item.Quantity * item.PurchasePrice)
      .reduce((sum, current) => sum + current);//-- * this.PurchaseOrderData.Items.filter((item) => item.Quantity)
    //.map((item) => +item.Quantity)
    //  .reduce((sum, current) => sum + current);
    this.PurchaseOrderData.GrandTotal = this.PurchaseOrderData.TotalBeforeTax + this.PurchaseOrderData.Tax;
    this.PurchaseOrderData.DiscountAmount = this.PurchaseOrderData.Items.filter((item) => item.Discount)
      .map((item) => +item.Discount)
      .reduce((sum, current) => sum + current);

    //this.PurchaseOrderData.GrandTotal = this.PurchaseOrderData.Items.filter((item) => item.PurchasePrice)
    //  .map((item) => +item.PurchasePrice)
    //  .reduce((sum, current) => sum + current) * this.PurchaseOrderData.Items.filter((item) => item.TotalOrderQuantity)
    //    .map((item) => +item.TotalOrderQuantity)
    //    .reduce((sum, current) => sum + current);
    //this.PurchaseOrderData.TotalBeforeTax = this.PurchaseOrderData.GrandTotal - this.PurchaseOrderData.Tax;

  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  Cancel() {
    this.router.navigate(['healins/povi']);
  }
  ShipToLocation: number = 0;
  public ShipToLocationname: string;
  onAssignedShipToLocationname(event: any) {
    if (event != null) {
      this.ShipToLocationname = event;
    }
  }

}
